module.exports = __webpack_public_path__ + "img/1010_pc.6bd86ffd.gif";